/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum APIStatusDaeEnum {
    NUMBER_0 = 0,
    NUMBER_1 = 1,
    NUMBER_2 = 2,
    NUMBER_3 = 3,
    NUMBER_4 = 4,
    NUMBER_5 = 5,
    NUMBER_6 = 6,
    NUMBER_7 = 7,
    NUMBER_8 = 8,
    NUMBER_9 = 9,
    NUMBER_10 = 10
}


export function instanceOfAPIStatusDaeEnum(value: any): boolean {
    for (const key in APIStatusDaeEnum) {
        if (Object.prototype.hasOwnProperty.call(APIStatusDaeEnum, key)) {
            if (APIStatusDaeEnum[key as keyof typeof APIStatusDaeEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function APIStatusDaeEnumFromJSON(json: any): APIStatusDaeEnum {
    return APIStatusDaeEnumFromJSONTyped(json, false);
}

export function APIStatusDaeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIStatusDaeEnum {
    return json as APIStatusDaeEnum;
}

export function APIStatusDaeEnumToJSON(value?: APIStatusDaeEnum | null): any {
    return value as any;
}

